export enum Kingdom {
  Animalia = 'Animalia',
  Plantae = 'Plantae',
  Fungi = 'Fungi',
  Protista = 'Protista',
  Monera = 'Monera',
}

export enum IUCNRedListCategory {
  EX = 'EX', // Extinct
  EW = 'EW', // Extinct in the Wild
  CR = 'CR', // Critically Endangered
  NT = 'NT', // Near Threatened
  EN = 'EN', // Endangered
  VU = 'VU', // Vulnerable
  LC = 'LC', // Least Concern
  DD = 'DD', // Data Deficient
  NE = 'NE', // Not Evaluated
}

export const IUCN_CATEGORY_COLORS: Record<IUCNRedListCategory, string> = {
  [IUCNRedListCategory.EX]: '#000000',
  [IUCNRedListCategory.EW]: '#6e6e6e',
  [IUCNRedListCategory.CR]: '#ff0000',
  [IUCNRedListCategory.EN]: '#ff6600',
  [IUCNRedListCategory.VU]: '#ffcc00',
  [IUCNRedListCategory.NT]: '#ffff00',
  [IUCNRedListCategory.LC]: '#00ff00',
  [IUCNRedListCategory.DD]: '#999999',
  [IUCNRedListCategory.NE]: '#cccccc',
} as const;
